import {
  NgbNav,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavContent,
  NgbScrollSpy,
  NgbScrollSpyFragment,
  NgbDropdownModule,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import {
  Component,
  computed,
  effect,
  inject,
  Injector,
  OnInit,
  Signal,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import {
  CreateUpdateSupplierDeliveryNoteDto,
  DayBookService,
  SupplierDeliveryNoteDefaultValueDto,
  SupplierDeliveryNoteDto,
  SupplierDeliveryNoteService,
  SupplierDeliveryStatus,
  ThirdPartyDocDefaultValueDto,
} from '@digiwall/goliath-documents/proxy';
import {
  AnnexesListComponent,
  CurrentCompanyStore,
  GoliathCoreEnumerationTypeStore,
} from '@digiwall/goliath-core';
import {
  LocalizationModule,
  SubscriptionService,
  ConfigStateService,
  LocalizationService,
} from '@abp/ng.core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormBuilder,
  AbstractControl,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { DocTemplateService } from '../../base-docs/detail/doc-template-selection/doc-template.service';

import {
  ChatComponent,
  conditionalValidator,
  DeactivatableComponentService,
  DwApiSelectDirective,
  DwDatePickerComponent,
  DwInputAutoCompleteDirective,
  DwInputRequiredDirective,
  DwReadonlyFormDirective,
  ErrorFormControlDirective,
  NewId,
  OdysseyOffcanvas,
} from '@digiwall/core';
import {
  CounterComponent,
  DropdownMenu,
  DropdownMenuComponent,
  PanelComponent,
} from '@digiwall/ui-kit';
import { DwGridDetailNavigationComponent, DwTabsComponent } from '@digiwall/ag-grid';
import { DwNavLinkDirective } from '@digiwall/core';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { DwKeyboardShortcutDirective } from '@digiwall/core';
import { DwScrollSpyDirective } from '@digiwall/ag-grid';
import { DocConditionsComponent } from '../../base-docs/detail/doc-conditions/doc-conditions.component';
import { DocClassificationsComponent } from '../../base-docs/detail/doc-classifications/doc-classifications.component';
import { CommonModule } from '@angular/common';
import { SidePanelComponent } from '@digiwall/ui-kit';
import { BaseSupplierDocDetail } from '../../base-supplier-docs/base-supplier-doc-detail';
import {
  ClassificationTypeService,
  DocRole,
  DwActiveLookupRequestDto,
  WarehouseService,
  WeightUnit,
} from '@digiwall/goliath-core/proxy';
import { ActivatedRoute, Router } from '@angular/router';
import { Confirmation, ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { BreadcrumbService } from 'xng-breadcrumb';
import { SupplierService } from '@digiwall/goliath-contacts/proxy';
import { GoliathContactsEnumerationTypeStore, SalesPersonStore } from '@digiwall/goliath-contacts';
import { DocSupplierOthersComponent } from '../../base-docs/detail/doc-supplier-others/doc-supplier-others.component';
import { SupplierDeliveryNoteLinesEditorComponent } from './supplier-delivery-note-lines/supplier-delivery-note-lines-editor.component';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { DialogBoxSelectSalesPurchaseComponent } from './select-sales-purchase-dialog-component/dialog-box-select-sales-purchase.component';
import { Observable } from 'rxjs';
import { BaseStockDocDetailHelperService } from '../../base-docs/detail/base-stock-doc-detail';
import { DocSidePanelComponent } from '../../base-docs/detail/doc-ui-components/doc-side-panel/doc-side-panel.component';
import {
  DocNumberTagComponent,
  DocumentCoreCardComponent,
  DocumentSupplierCardComponent,
  SupplierDocumentDateCardComponent,
  SupplierDocumentStatusCardComponent,
} from '../../../components';
import { NgSelectModule } from '@ng-select/ng-select';
import { StockValidationSharedLogicService } from '../../stock-validation-shared-logics/stock-validation-shared-logic.service';
import moment from 'moment';

@Component({
  selector: 'document-supplier-delivery-note-detail',
  templateUrl: './supplier-delivery-note-detail.component.html',
  styleUrl: './supplier-delivery-note-detail.component.scss',
  providers: [
    BaseStockDocDetailHelperService,
    DocTemplateService,
    SubscriptionService,
    StockValidationSharedLogicService,
  ],
  imports: [
    CommonModule,
    PanelComponent,
    DwTabsComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    DwNavLinkDirective,
    NgbNavContent,
    NgbScrollSpy,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    DwKeyboardShortcutDirective,
    NgbScrollSpyFragment,
    DwScrollSpyDirective,
    DocConditionsComponent,
    DocClassificationsComponent,
    DocSupplierOthersComponent,
    AnnexesListComponent,
    NgbDropdownModule,
    DropdownMenuComponent,
    NgbNavOutlet,
    SidePanelComponent,
    FormsModule,
    CounterComponent,
    LocalizationModule,
    SupplierDeliveryNoteLinesEditorComponent,
    DwReadonlyFormDirective,
    ChatComponent,
    DwGridDetailNavigationComponent,
    DocSidePanelComponent,
    DocumentCoreCardComponent,
    DocumentSupplierCardComponent,
    SupplierDocumentDateCardComponent,
    SupplierDocumentStatusCardComponent,
    DwDatePickerComponent,
    DwInputAutoCompleteDirective,
    DwInputRequiredDirective,
    NgSelectModule,
    DwApiSelectDirective,
    ErrorFormControlDirective,
    DocNumberTagComponent,
  ],
})
export class SupplierDeliveryNoteDetailComponent
  extends BaseSupplierDocDetail<
    SupplierDeliveryNoteService,
    SupplierDeliveryNoteDto,
    CreateUpdateSupplierDeliveryNoteDto,
    SupplierDeliveryNoteDefaultValueDto
  >
  implements OnInit
{
  currentCompanyStore = inject(CurrentCompanyStore);
  enumerationTypeStore = inject(GoliathDocumentsEnumerationTypeStore);
  contactEnumerationTypeStore = inject(GoliathContactsEnumerationTypeStore);
  coreEnumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);
  salesPersonStore = inject(SalesPersonStore);
  stockValidationSharedLogicService = inject(StockValidationSharedLogicService);

  @ViewChild('supplierDeliveryNoteLineGrid') docLineGrid: any;
  @ViewChild('docSidePanel') docSidePanel: DocSidePanelComponent;

  protected _document: SupplierDeliveryNoteDto;
  protected selectedPurchaseOrderSelectedIds: string[];
  public get document() {
    return this.entity;
  }

  public get saveFromExtends() {
    return super.save;
  }

  public get afterSaveFromExtends() {
    return super.afterSave;
  }

  public get navigateAfterSaveFromExtends() {
    return super.navigateAfterSave;
  }

  weightUnits = WeightUnit;
  docRole = DocRole.SupplierDeliveryNote;
  SupplierDeliveryStatus = SupplierDeliveryStatus;

  private validateInProgress: boolean = false;

  get newId() {
    return NewId;
  }

  actions: Signal<DropdownMenu> = computed(() => ({
    groups: [
      this.baseActionsThirdPartyDoc().concat(
        {
          label: 'Doc::SupplierDeliveryNote:SelectSalesPurchase',
          icon: 'digi-out-edit-square',
          enabled: computed(
            () =>
              this.entitySignal() &&
              this.entitySignal().deliveryStatus != SupplierDeliveryStatus.CheckValuation &&
              this.entitySignal().deliveryStatus != SupplierDeliveryStatus.Closed,
          ),
          action: () => this.selectSalePurchase(),
        },
        {
          label: 'Doc::SupplierDeliveryNote:UpdateWhenValidated',
          icon: 'digi-out-edit-square',
          enabled: computed(
            () =>
              this.entitySignal() &&
              !this.hasLinkedReturnNotes() &&
              (this.entitySignal().deliveryStatus == SupplierDeliveryStatus.CheckValuation ||
                this.entitySignal().deliveryStatus == SupplierDeliveryStatus.Closed),
          ),
          action: () => this.updateWhenValidated(),
        },
        {
          label: 'Doc::SupplierDeliveryNote:Cancel',
          icon: 'digi-out-edit-square',
          enabled: computed(
            () =>
              this.entitySignal() &&
              !this.hasLinkedReturnNotes() &&
              (this.entitySignal().deliveryStatus == SupplierDeliveryStatus.CheckValuation ||
                this.entitySignal().deliveryStatus == SupplierDeliveryStatus.Closed),
          ),
          action: () => this.cancel(),
        },
      ),
    ],
  }));

  protected saveActionBtns = computed(() => {
    let btns = [
      {
        label: this.localizationService.instant('::Save'),
        action: () => this.save(),
        labelSignal: computed(() => {
          return this.localizationService.instant('::Save');
        }),
        disabled: () =>
          this.entitySignal()?.deliveryStatus == SupplierDeliveryStatus.Closed ||
          !this.form.dirty ||
          !this.stockValidationSharedLogicService.canSave(),
      },
    ];
    return btns;
  });

  hasLinkedReturnNotes: WritableSignal<boolean> = signal(false);

  protected supplierDeliveryStatus = computed(() => {
    return this.entitySignal()?.deliveryStatus == SupplierDeliveryStatus.Closed
      ? this.enumerationTypeStore.supplierDeliveryStatus()
      : this.enumerationTypeStore
          .supplierDeliveryStatus()
          .filter(status => status.uniqueCode != SupplierDeliveryStatus.Closed);
  });

  constructor(
    route: ActivatedRoute,
    router: Router,
    subscriptionService: SubscriptionService,
    supplierDeliveryNoteService: SupplierDeliveryNoteService,
    formBuilder: FormBuilder,
    toastService: ToasterService,
    breadcrumbService: BreadcrumbService,
    dayBookService: DayBookService,
    localizationService: LocalizationService,
    injector: Injector,
    supplierService: SupplierService,
    config: ConfigStateService,
    docTemplateService: DocTemplateService,
    classificationTypeService: ClassificationTypeService,
    confirmationService: ConfirmationService,
    deactivableComponentService: DeactivatableComponentService,
    private warehouseService: WarehouseService,
    private stockHelper: BaseStockDocDetailHelperService,
  ) {
    super(
      route,
      router,
      subscriptionService,
      supplierDeliveryNoteService,
      formBuilder,
      toastService,
      breadcrumbService,
      dayBookService,
      localizationService,
      classificationTypeService,
      docTemplateService,
      injector,
      supplierService,
      config,
      confirmationService,
      deactivableComponentService,
    );
    stockHelper.Doc = this;

    effect(() => {
      if (
        this.entitySignal() &&
        this.entitySignal().id != NewId &&
        this.entitySignal().id != null
      ) {
        this.docService
          .hasLinkedReturnNote(this.entitySignal().id)
          .subscribeOnce(hasLinkedReturnNotes => {
            this.hasLinkedReturnNotes.set(hasLinkedReturnNotes);
          });
      }
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.stockValidationSharedLogicService.setup({
      isCreationMode: this.isCreationMode,
      isValidated: this.isValidated,
      lineCount: this.lineCount,
      isStockValidated: computed(() => {
        const entity = this.entitySignal();
        return this.isStockValidated() && entity.deliveryStatus == SupplierDeliveryStatus.Closed;
      }),
    });
    this.init();
  }
  override get formModel() {
    let formModel = super.formModel;
    if (this.isSerialEntry) {
      formModel = Object.assign({}, formModel, {
        copyLineData: [false],
        printLabel: [false],
      });
    }
    formModel = Object.assign({}, formModel, {
      receivedDate: [
        null,
        conditionalValidator(
          () => this.form.get('documentDate')?.value,
          (control: AbstractControl): ValidationErrors | null => {
            const docDate = this.form?.get('documentDate')?.value;
            const deliveryDate = control.value;
            if (!docDate || !deliveryDate) return null;
            return moment(deliveryDate).isSameOrBefore(docDate, 'day')
              ? null
              : {
                  invalidDate: false,
                };
          },
          () => {
            return [this.form.get('documentDate').valueChanges];
          },
        ),
      ],
      additionalCostPricePercentage: [null],
      warehouseId: [null],
      deliveryStatus: [null, Validators.required],
    });
    return formModel;
  }

  protected warehouseSelect = (dto: DwActiveLookupRequestDto<string>) => {
    dto.onlyActive = true;
    dto.sorting = [{ property: 'name' }];
    dto.queryProperties = ['code', 'name'];
    return this.warehouseService.getLookupList(dto);
  };

  private selectSalePurchase() {
    const offcanvasRef = this.offcanvasService.open(DialogBoxSelectSalesPurchaseComponent, null);
    const componentInstance: DialogBoxSelectSalesPurchaseComponent = offcanvasRef.componentInstance;
    componentInstance.documentId = this.entity.id;
    componentInstance.docService = this.docService;
    componentInstance.supplierId = this.form.get('thirdPartyId').value;
    componentInstance.isSerialEntry = this.isSerialEntry;
    componentInstance.closeFn = (purchaseOrderSelectedId: string[]) => {
      this.selectedPurchaseOrderSelectedIds = purchaseOrderSelectedId;
    };
    offcanvasRef.dismissed.subscribe(() => {
      if (this.selectedPurchaseOrderSelectedIds == null) {
        this.getEntity(this.docId);
      }
    });
  }

  override saveRequest(): Observable<SupplierDeliveryNoteDto> {
    this.form.markAllAsTouched();
    if (this.form.invalid || this.form.disabled) return;

    let formValue = Object.assign(
      { validatedDoc: true },
      this.form.value,
    ) as CreateUpdateSupplierDeliveryNoteDto;

    const request = this.entity.id
      ? this.docService.update(this.entity.id, formValue)
      : this.docService.create(formValue);

    return request as Observable<SupplierDeliveryNoteDto>;
  }

  private updateWhenValidated() {
    this.docService
      .updateWhenValidated(this.entity.id)
      .subscribeOnce(amendValidatedSupplierDeliveryNoteResponse => {
        this.toastService.success(this.localizationService.instant('::SavedSuccessfully'));
        this.router.navigate(
          ['../', amendValidatedSupplierDeliveryNoteResponse.supplierDeliveryNoteId],
          { relativeTo: this.route },
        );
      });
  }

  private cancel() {
    const confirm$ = this.confirmationService.warn(
      this.localizationService.instant(
        'Doc::SupplierDeliveryNote:AreYouSureYouWantToCancelMessage',
      ),
      this.localizationService.instant('Doc::SupplierDeliveryNote:AreYouSureYouWantToCancelTitle'),
    );
    this.subscriptionService.addOne(confirm$, status => {
      if (status == Confirmation.Status.confirm) {
        this.docService.cancel(this.entity.id).subscribeOnce(() => {
          this.toastService.success(
            this.localizationService.instant('Doc::SupplierDeliveryNote:Cancelled'),
          );
          var temp = this.entity.id;
          this.entity.id = null;
          this.entity.id = temp;

          this.refreshEntity();
          this.docSidePanel.refreshHierarchy();
        });
      }
    });
  }

  get isSerialEntry() {
    return this.router.url.split('/').includes('entry');
  }

  override save() {
    if (!this.docLineGrid) {
      super.save();
      return;
    }

    this.docLineGrid.beforeSaveDocument().subscribeOnce(() => {
      super.save();
    });
  }

  override setDefaultValue(response: ThirdPartyDocDefaultValueDto) {
    super.setDefaultValue(response);
    if (this.isSerialEntry) {
      this.form.get('copyLineData').setValue(true);
      this.form.get('printLabel').setValue(true);
    }
  }

  protected override async afterGetEntity(response: SupplierDeliveryNoteDto): Promise<void> {
    await super.afterGetEntity(response);
    this.subscribeToFormValueChanges();
  }

  protected override afterSave(): void {
    super.afterSave();
    if (this.validateInProgress) {
      this.docService.validateStock(this.entity.id).subscribeOnce(() => {
        this.refreshEntity();
        this.validateInProgress = false;
        this.toastService.success('Doc::CustomerQuote:IsValidated');
      });
    } else {
      this.subscribeToFormValueChanges();
    }
  }

  protected validateStock() {
    this.validateInProgress = true;
    this.save();
  }

  public override canDeactivate = async () => {
    this.canDeactivateTitle = this.stockValidationSharedLogicService.getCanDeactivateTitle();
    return !this.form.dirty;
  };
}
